function sendGa(category, action, label) {
    ga('send', {
        hitType: 'event',
        eventCategory: category,
        eventAction: action,
        eventLabel: label
    });
}

$(function() {

    $('.js-scroll-link').on('click', function() {
        var target = $(this).attr('href');
        $(window).scrollTo($(target), 800, {offset: -50, easing: 'swing'});
        if ($(window).width() < 769) {
            $('.js-nav-wrapper').removeClass('show');
            $('.js-nav-trigger').removeClass('active');
            $('body').removeClass('overflow');
        }

        var type = $(this).data('type');
        sendGa('internal', 'click', type);
    });

    $('.js-btn-start').on('click', function() {
        $('.intro').addClass('step2');
        sendGa('internal', 'click', 'start_test');
        return false;
    });

    $('.js-promo-link').on('click', function () {
        sendGa('external', 'click', 'show_more');
    });

    var scrollPercent;

    $(window).on('scroll', function(){
        var s = $(window).scrollTop(),
            d = $(document).height(),
            c = $(window).height();

        percent = (s / (d - c)) * 100;
        scrollPercent = Math.ceil(percent / 10) * 10;
    });

    $(window).on('beforeunload', function() {
        sendGa('internal', 'scroll', scrollPercent, 'scroll_'+scrollPercent);
    });

    $('.js-child').hover(
        function() {
            if ($(this).closest('.step2').length) {
                var n = $(this).index();
                var leads = $('.js-lead');
                $(this).siblings().addClass('blur');
                $(this).removeClass('blur');
                $(this).addClass('hover');
                $('.js-screen2').addClass('hide');
                $.each(leads, function() {
                    $(this).removeClass('show');
                    if ($(this).index() === n) {
                        $(this).addClass('show');
                    }
                });
            }
        },

        function() {
            $(this).removeClass('hover');
        }
    );

    $('.js-child').on('click', function() {
        if ($(this).closest('.step2').length) {
            var i = $(this).index();
            var leads = $('.js-lead');
            var sliders = $('.js-slider');
            $('.js-leads').addClass('hide');
            $.each(sliders, function() {
                $(this).removeClass('show');
                if ($(this).index() === i) {
                    $(this).addClass('show');
                }
            });
            //leads.removeClass('show');
            var index = parseFloat(i)+1;

            sendGa('internal', 'click', 'item_'+index);
        }
    });

    $('.js-child-mob').on('click', function() {
        if ($(this).closest('.step2').length) {
            var i = $(this).index();
            var leads = $('.js-lead');
            var child = $('.js-child');
            var sliders = $('.js-slider');

            child.addClass('blur');
            child.eq(i).removeClass('blur');
            $(this).siblings().addClass('blur');
            $(this).removeClass('blur');

            $('.js-leads').addClass('hide');
            $.each(sliders, function() {
                $(this).removeClass('show');
                if ($(this).index() === i) {
                    $(this).addClass('show');
                }
            });
            //leads.removeClass('show');
            var index = parseFloat(i)+1;

            sendGa('internal', 'click', 'item_'+index);
        }
    });

    // $('.js-child-mob').on('click', function() {
    //     var m = $(this).index();
    //     var leads = $('.js-lead');
    //     $(this).siblings().addClass('blur');
    //     $(this).removeClass('blur');
    //     $('.js-screen2').addClass('hide');
    //     $('.js-leads').removeClass('hide');
    //     $('.js-slider').removeClass('show');
    //
    //     $.each(leads, function() {
    //         $(this).removeClass('show');
    //         if ($(this).index() === m) {
    //             $(this).addClass('show');
    //         }
    //     });
    // });

    if ($(window).width() < 789) {
        var triggers = $('.js-child-mob');
        $('.js-lead').swipe( {
            swipe: function(event, direction, distance, duration, fingerCount, fingerData) {
                var ind = $(this).index();
                if (direction === 'left') {
                    if ($(this).next('.js-lead').length) {
                        $(this).removeClass('show');
                        $(this).next('.js-lead').addClass('show');
                        $.each(triggers, function() {
                            $(this).addClass('blur');
                            if ($(this).index() === ind + 1) {
                                $(this).removeClass('blur');
                            }
                        });
                    } else {
                        return false;
                    }
                } else if (direction === 'right') {
                    if ($(this).prev('.js-lead').length) {
                        $(this).removeClass('show');
                        $(this).prev('.js-lead').addClass('show');
                        $.each(triggers, function() {
                            $(this).addClass('blur');
                            if ($(this).index() === ind - 1) {
                                $(this).removeClass('blur');
                            }
                        })
                    } else {
                        return false;
                    }
                }
            }
        });
        $('.js-child').on('click', function() {
            if ($(this).closest('.step2').length) {
                var childInd = $(this).index();
                var childTriggers = $('.js-child-mob');
                var childLeads = $('.js-lead');
                $.each(childTriggers, function() {
                    $(this).addClass('blur');
                    if ($(this).index() === childInd) {
                        $(this).removeClass('blur');
                    }
                })
            }
        })
    };

    $('.js-nav-trigger').on('click', function() {
        $(this).toggleClass('active');
        $('.js-nav-wrapper').toggleClass('show');
        $('body').toggleClass('overflow');
    })

    var swiperSlider = $('.swiper-container');
    swiperSlider.each(function() {
        var options = $(this).data('options') || {},
            $parent = $(this).parent(),
            swiperDefaults = {
                loop: true,
                navigation: {
                    nextEl: $parent.find('.swiper-button-next')[0],
                    prevEl: $parent.find('.swiper-button-prev')[0],
                },
            };

        var swiperOptions = $.extend(swiperDefaults, options),
            mySwiper = new Swiper(this, swiperOptions);
    });

    var animatedEls = $('.js-animate');

    $.each(animatedEls, function() {
        var scrollDistance = $(this).offset().top;
        var windowHeight = $(window).height();
        if (scrollDistance < windowHeight) {
            $(this).addClass('start-animation');
        }
    });

    $(window).scroll(function() {
        var windowScroll = $(this).scrollTop();

        $.each(animatedEls, function() {
            var scrollDistance = $(this).offset().top;
            var windowHeight = $(window).height();
            if ($(this).height() < windowHeight) {
                if (windowScroll <= scrollDistance && ($(this).height()/2 + scrollDistance) < (windowScroll + windowHeight)) {
                    $(this).addClass('start-animation');
                }
            } else if ($(this).height() >= windowHeight) {
                if (windowScroll <= scrollDistance && ($(this).height()/5 + scrollDistance) < (windowScroll + windowHeight)) {
                    $(this).addClass('start-animation');
                }
            }
        });
    });

    $('.social--mobile').each(function () {
        var myShare = $(this).get(0);

        var share = Ya.share2(myShare, {
            theme: {
                services: 'facebook,vkontakte,twitter,odnoklassniki,',
                bare: true
            },
            content: {
                url: location.href,
                title: 'Настрой ребенка на лучшее',
                description: 'Раствор Магне В6 восполняет дефицит магния, что поддержит баланс в нервной системе ребенка',
                image: 'http://magnekids.letidor.ru/share.jpg'
            }
        });
    });

    $('.social--desktop').each(function () {
        var myShare = $(this).get(0);

        var share = Ya.share2(myShare, {
            theme: {
                services: 'facebook,vkontakte,twitter,telegram,',
                bare: true
            },
            content: {
                url: location.href,
                title: 'Настрой ребенка на лучшее',
                description: 'Раствор Магне В6 восполняет дефицит магния, что поддержит баланс в нервной системе ребенка',
                image: 'http://magnekids.letidor.ru/share.jpg'
            }
        });
    });

    $('.ya-share2__link').on('click', function () {
        sendGa('internal', 'click', 'share');
    });
});